import { useTranslator } from "@eo-locale/react";

import { Box, Button, Text } from "@/storybook-components";
import { useAppDispatch, useAppSelector } from "@/redux/store/hooks";
import { resetFinder, setCurrentPage } from "@/redux/features/projects/slice";

const ResetFilter = (): JSX.Element => {
  const { translate } = useTranslator();
  const dispatch = useAppDispatch();
  const { queryFilter } = useAppSelector((state) => state.projectFinder);
  const { locales } = queryFilter;

  const handleChange = () => {
    dispatch(resetFinder());
    dispatch(setCurrentPage(1));
  };

  return (
    <>
      <Box
        p={2}
        w={["100%", "100%", "15%", "15%"]}
        className="ehq-projectsResetFilterButtonContainer"
      >
        <Button
          variant="primary"
          w="100%"
          fontSize="sm"
          display="block"
          overflow="hidden"
          onClick={() => handleChange()}
          className="ehq-projectsResetFilterButton"
          data-tname="projects-filter-reset-button"
        >
          <Text className="ehq-projectResetButtonText">
            {locales["projects.resetBtn"] ||
              translate("projectFinder.resetBtn")}
          </Text>
        </Button>
      </Box>
      <style jsx global>{`
        .ehq-projectResetButtonText {
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
      `}</style>
    </>
  );
};

export default ResetFilter;
